import { Component, signal, ChangeDetectionStrategy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { User } from "../entity/User";
import { MatDialog } from "@angular/material/dialog";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { AbstractComponent } from "./abstract/abstract.component";
import { FAQ } from "../entity/FAQ";
import { HeaderComponent } from "./incs/header.component";

@Component({
    selector: "kilowant-faq",
    templateUrl: "../../html/main-faq.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent]
})
export class FAQComponent extends AbstractComponent {
    user: User | null = null;
    faq = signal<FAQ[]>([]);
    faqOpenQuestion = signal<number>(-1);
    contactUsOpened: boolean = false;
    constructor(
        router: Router,
        route: ActivatedRoute,
        private authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog
    ) { super(router, route, dialog, analyticsService, generalService); }

    ngOnInit(): void {
        if (this.authService.isLoggedIn()) {
            this.initPromises.push(this.loadUser());
        }
        super.ngOnInit();
    }

    pageStart(): void {
        this.generalService.getFAQ(0).subscribe(
            (res: any) => { this.faq.set(<FAQ[]>res); }
        );
    }

    loadUser(): Promise<User> {
        return this.generalService.getDetails()
            .then(u => {
                if (u == null) {
                    this.user = null;
                } else {
                    this.user = Object.assign(new User(), u);
                }
                return u;
            });
    }

    getBaseLink() {
        return this.router.url.split('#')[0];
    }

    viewQuestion(i: number): void {
        if (this.faqOpenQuestion() == i) {
            this.faqOpenQuestion.set(-1);
        } else {
            this.faqOpenQuestion.set(i);
        }
    }

    mailing(): void {
        window.location.href = 'mailto:info@kilowant.com?subject=Kilowant Contact';
    }

    contactOpen(): void {
        this.contactUsOpened = !this.contactUsOpened;
        if (this.contactUsOpened) {
            this.analyticsService.trackEvent("open_view", { label: "contact_us" });
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
